import React, { useState, useEffect } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";
import DropZone from "../../component/dropzone/DropZone";

const AddStudent = () => {
  const token = config.token;
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // ------------------------------------------ state management ------------------------------------------
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    dob: "",
    mobileno: "",
  });

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      dob: "",
      mobileno: "",
    });

    if (id) {
      navigate("/viewstudents");
    }
  };

  // ------------------------------------------------- Create / Add student -----------------------------------C
  const handleCreateStudent = async () => {
    // --- Require field validation ---
    if (
      !formData.first_name.trim() ||
      !formData.last_name.trim() ||
      !formData.email.trim() ||
      formData.dob === "" ||
      formData.mobileno === "" ||
      formData.mobileno === null
    ) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return; // Stop form submission
    }

    try {
      if (!token) {
        triggerNotification("error", "Please log in to create a teacher");
        return;
      }
      await fetch(
        `${config.host_url}student/${
          id ? decodeURIComponent(atob(id)) : "add/"
        }`,
        {
          method: id ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify(formData),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `Teacher ${id ? "updated" : "created"} successfully.`
            );
            setFormData({
              first_name: "",
              last_name: "",
              email: "",
              mobileno: "",
              dob: "",
            });

            navigate("/viewstudents");
          } else if (data.status === 400) {
            // Handle validation errors if any
            const errorMsgs = Array.isArray(data.msg)
              ? data.msg.join(", ")
              : data.msg;
            console.log("Error: ", errorMsgs);
            triggerNotification("error", `Validation Error`);
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated user!");
          } else {
            triggerNotification("error", "Internal Server Error");
          }
        });
    } catch (error) {
      triggerNotification(
        "error",
        "Some Error Occurred!! Please try again later"
      );
    }
  };

  // --------------------------------------- set data for Edit form -----------------------------------
  const updateFieldValueSet = async (id) => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}student/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            const responseData = data.data;
            const serverDate = await new Date(responseData.dob);
            const formattedDate = serverDate.toISOString().split("T")[0];

            await setFormData({
              first_name: responseData.first_name,
              last_name: responseData.last_name,
              email: responseData.email,
              dob: formattedDate,
              mobileno: responseData.mobileno,
            });
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      updateFieldValueSet(id);
    }
  }, [id]);
  return (
    <>
      <Breadcrumb txt="Manage Student" subpath={["Add Student"]} />
      {!id && (
        <DropZone
          url="student/excel"
          navigate="viewstudents"
          title="Add Student from an Excel File"
        />
      )}
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Student</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-md-6">
                    {/* Student first_name */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="first_name"
                        id="first_name"
                        placeholder="First Name"
                        value={formData.first_name}
                        onChange={handleChange}
                      />
                      <label htmlFor="first_name"> First Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* Student last_name */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="last_name"
                        id="last_name"
                        placeholder="Last Name"
                        value={formData.last_name}
                        onChange={handleChange}
                      />
                      <label htmlFor="last_name">Last Name</label>
                    </div>
                  </div>
                </div>

                {/* Email Address */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <label htmlFor="email">Email Address</label>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    {/* dob */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="date"
                        className="form-control"
                        name="dob"
                        id="dob"
                        placeholder="Date Of Birth"
                        value={formData.dob}
                        onChange={handleChange}
                      />
                      <label htmlFor="dob">Date Of Birth</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* mobileno */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="number"
                        className="form-control"
                        name="mobileno"
                        id="mobileno"
                        placeholder="Mobile Number"
                        value={formData.mobileno}
                        onChange={handleChange}
                      />
                      <label htmlFor="mobileno">Mobile Number</label>
                    </div>
                  </div>
                </div>

                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleCreateStudent}
                    >
                      {id ? "Update" : "Submit"}
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddStudent;
